import RoomDetailPage from '@/pages/room/room-detail'
import EditRoomElecStatus from '@/pages/room/editRoomElecStatus'

// 订单统计报表
export const roomDetail = {
  path: 'room/roomDetail',
  component: RoomDetailPage
}

// 修改房间通电状态
export const editRoomElecStatus = {
  path: 'room/editRoomElecStatus',
  component: EditRoomElecStatus
}


// WEBPACK FOOTER //
// ./src/router/room.js